module.exports = __webpack_public_path__ + "img/cycle-hero.f1f3bc93.jpg";